/* FUROVA sales page app — core (buy-box styling now lives in the section markup; sticky ATC bar lives in furova-hero.js) */
(function () {
  if (window.FUROVA) return;
  var F = window.FUROVA = {
    booted: false,
    state: { model: 'm32', bundle: false, qty: 1, gallery: 0, compTab: 'm32', reviewFilter: 'All', reviewsShown: 9, popupShown: false },
    data: { models: {}, order: ['m22', 'm32', 'm4'], filter: null, reviews: [] },
    cart: null,
    listeners: []
  };
  F.onChange = function (fn) { F.listeners.push(fn); };
  F.set = function (patch) { Object.assign(F.state, patch); F.listeners.forEach(function (fn) { try { fn(F.state); } catch (e) { console.error(e); } }); };
  F.sel = function () { return F.data.models[F.state.model] || null; };
  F.money = function (cents) { if (cents === null || cents === undefined) return null; return '$' + (cents / 100).toFixed(2); };

  /* ---- customer-facing message. Never alert(): a native dialog blocks the
     page, cannot be styled, and previously leaked developer copy about Draft
     products to real shoppers. Writes into [data-fv-atc-msg] when present. ---- */
  F.notify = function (msg) {
    var slots = document.querySelectorAll('[data-fv-atc-msg]');
    if (!slots.length) { console.warn('[FUROVA] ' + msg); return; }
    slots.forEach(function (el) {
      el.textContent = msg;
      el.style.display = 'block';
      clearTimeout(el._fvT);
      el._fvT = setTimeout(function () { el.textContent = ''; el.style.display = 'none'; }, 6000);
    });
  };

  /* ---- data registration from sections ---- */
  F.scan = function () {
    document.querySelectorAll('script[type="application/json"][data-fv-models]').forEach(function (s) {
      try {
        var d = JSON.parse(s.textContent);
        if (d.models) Object.keys(d.models).forEach(function (k) { F.data.models[k] = d.models[k]; });
        if (d.filter) F.data.filter = d.filter;
      } catch (e) { console.error('FUROVA models JSON', e); }
    });
  };

  /* ---- gallery slide decks (legacy fallback for other sections) ---- */
  F.slidesFor = function (key) {
    var M = F.data.models[key]; if (!M) return [];
    var full = M.name + ' ' + M.capacity;
    return [
      { tag: 'Hero', kicker: 'The fountain', title: full, lines: [], label: full },
      { tag: 'Steel', kicker: 'The material', title: '100% stainless steel', lines: ['Wipes clean — no plastic slime'], label: full },
      { tag: 'Quiet', kicker: 'The pump', title: 'Whisper-quiet pump', lines: ['Quiet enough for the bedroom'], label: full },
      { tag: 'Guarantee', kicker: 'Risk reversal', title: '30-Day Happiness Guarantee', lines: ['Try it risk-free at home'], label: full }
    ];
  };

  /* ---- cart (real Shopify AJAX cart) ---- */
  F.refreshCart = function () {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { F.cart = c; F.emitCart(); return c; }).catch(function () {});
  };
  F.emitCart = function () { document.dispatchEvent(new CustomEvent('fv:cart', { detail: F.cart })); };

  /* Returns a promise so callers can show a loading state and re-enable the
     button when the round trip settles. */
  F.addToCart = function () {
    var M = F.sel();
    if (!M || !M.variantId) {
      F.notify('Sorry — that size is unavailable right now. Please pick another.');
      return Promise.reject(new Error('no variant'));
    }
    var items = [{ id: M.variantId, quantity: F.state.qty }];
    if (F.state.bundle && F.data.filter && F.data.filter.variantId) items.push({ id: F.data.filter.variantId, quantity: 1 });
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return F.refreshCart(); })
      .then(function () { F.set({ qty: 1 }); F.openCart(); })
      .catch(function (e) {
        F.notify('Something went wrong adding that to your cart. Please try again.');
        throw e;
      });
  };
  F.changeLine = function (key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { F.cart = c; F.emitCart(); return c; });
  };
  F.addFilterToCart = function () {
    if (!F.data.filter || !F.data.filter.variantId) return Promise.reject(new Error('no filter'));
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: F.data.filter.variantId, quantity: 1 }] }) })
      .then(function () { return F.refreshCart(); });
  };
  F.openCart = function () { document.dispatchEvent(new CustomEvent('fv:opencart')); };
  F.closeCart = function () { document.dispatchEvent(new CustomEvent('fv:closecart')); };

  /* ---- body scroll lock ---- */
  F.lock = function (on) { document.body.classList.toggle('fv-lock', !!on); };

  /* ---- review modal (shared) ---- */
  F.openReview = function (r, returnEl) {
    var modal = document.querySelector('[data-fv-modal]'); if (!modal) return;
    F._modalReturn = returnEl || document.activeElement;
    var q = function (sel) { return modal.querySelector(sel); };
    q('[data-fv-m-initials]').textContent = r.initials || (r.name || '').split(' ').map(function (w) { return w[0]; }).join('');
    q('[data-fv-m-name]').textContent = r.name || '';
    q('[data-fv-m-starpct]').style.width = ((parseFloat(r.rating) / 5) * 100) + '%';
    q('[data-fv-m-rating]').textContent = r.rating + ' / 5';
    q('[data-fv-m-title]').textContent = r.title || '';
    q('[data-fv-m-text]').textContent = r.text || '';
    var names = { '2.2L': 'Furova Flow™ 2.2L', '3.2L': 'Furova Flow Plus™ 3.2L', '4L': 'Furova Flow Sense™ 4L' };
    q('[data-fv-m-model]').textContent = names[r.model] || r.model || '';
    q('[data-fv-m-date]').textContent = r.date || '';
    q('[data-fv-m-verified]').classList.toggle('fv-hidden', !(r.verified === true || r.verified === 'true'));
    modal.classList.remove('fv-hidden');
    F.lock(true);
    var closeBtn = modal.querySelector('[data-fv-m-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
  };
  F.closeReview = function () {
    var modal = document.querySelector('[data-fv-modal]'); if (!modal) return;
    if (modal.classList.contains('fv-hidden')) return;
    modal.classList.add('fv-hidden');
    F.lock(false);
    if (F._modalReturn && F._modalReturn.focus) setTimeout(function () { F._modalReturn.focus(); }, 30);
  };
  /* wire any element with data-fv-open-review='{json}' */
  F.wireReviewOpeners = function (root) {
    (root || document).querySelectorAll('[data-fv-open-review]').forEach(function (el) {
      if (el._fvWired) return; el._fvWired = true;
      var open = function (e) { try { F.openReview(JSON.parse(el.getAttribute('data-fv-open-review')), el); } catch (err) {} };
      el.addEventListener('click', open);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(e); } });
    });
  };

  /* ---- global escape key ---- */
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    F.closeCart();
    document.dispatchEvent(new CustomEvent('fv:closemenu'));
    document.dispatchEvent(new CustomEvent('fv:closepopup'));
    F.closeReview();
  });

  /* ---- boot ---- */
  function boot() { F.booted = true; F.scan(); F.refreshCart(); document.dispatchEvent(new CustomEvent('fv:ready')); F.wireReviewOpeners(); F.set({}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { F.scan(); F.wireReviewOpeners(); F.set({}); });
})();
